<template>
  <div>
    <van-nav-bar
          left-arrow
          @click-left="onClickLeft"
      />
    <div class="img1"/>
    <div style="height: 2px"> </div>
    <van-tabs style="margin-top: 50px">
      <van-tab title="企业" name="a" v-if="memType===2" >
        <van-form @submit="updateUserData(2)">
          <van-field
              v-model="headerName"  maxlength="60"
              placeholder="抬头名称"
              required
              label="抬头名称"
              :disabled="disableUp"
              :rules="[{ required: true, message: '请填写抬头名称' }]"
          />
          <van-field
              v-model="identificationNumber"
              name="纳税人识别号"
              required
              :disabled="disableUp"
              label="纳税人识别号"
              placeholder="纳税人识别号"
              :rules="[{ required: true, message: '请填写纳税人识别号' }]"
          />
          <van-field
              v-model="businessAddress"
              name="地址电话"
              required
              label="地址电话"
              :disabled="disableUp"
              placeholder="地址电话"
              :rules="[{ required: true, message: '请填写企业地址' }]"
          />
          <van-field
              v-model="bankAccount"
              name="银行账号"
              required
              label="银行账号"
              :disabled="disableUp"
              placeholder="银行账号"
              :rules="[{ required: true, message: '请填写银行账号' }]"
          />
          <van-field v-model="email" placeholder="邮箱" />
          <van-field
              v-model="phone"
              required
              clearable
              label="请输入手机号"
              :disabled="disableUp"
              placeholder="请输入手机号"
              :rules="[
                          { required: true, message: '请输入手机号' },
                          { validator, message: '手机号格式不正确' }
                          ]"
          />
          <van-field v-model="remarks" placeholder="备注" />
          <div class="button-group">
            <van-button
                :loading="loginloading" round  type="info"
                size="normal"
                v-if="disableUp"
                style="width: 93%;margin: 2px auto"
                native-type="submit"
            >修改</van-button>
            <van-button
                :loading="loginloading" round  type="info"
                size="normal"
                v-if="!disableUp"
                style="width: 93%;margin: 2px auto"
                native-type="submit"
            >保存</van-button>
          </div>
        </van-form>
      </van-tab>
      <van-tab title="个人及事业单位" label="个人及事业单位" name="b" v-if="memType==='1'">
        <van-form @submit="updateUserData(1)">
          <van-field
              v-model="headerName"
              name="抬头名称" maxlength="60"
              required
              label="抬头名称："
              :disabled="disableUp"
              placeholder="抬头名称"
              :rules="[{ required: true, message: '请填写抬头名称' }]"
          />
          <van-field v-model="email" label="邮  箱：" :disabled="disableUp" placeholder="邮箱" />
          <van-field
              v-model="phone"
              required
              clearable
              label="手机号："
              :disabled="disableUp"
              placeholder="请输入手机号"
              :rules="[
                          { required: true, message: '请输入手机号' },
                          { validator, message: '手机号格式不正确' }
                      ]"
          />
          <van-field v-model="remarks" placeholder="备注" />
          <div class="button-group">
            <van-button
                :loading="loginloading" round  type="info"
                size="normal"
                v-if="disableUp"
                style="width: 93%;margin: 2px auto"
                native-type="submit"
            >修改</van-button>
            <van-button
                :loading="loginloading" round  type="info"
                size="normal"
                v-if="!disableUp"
                style="width: 93%;margin: 2px auto"
                native-type="submit"
            >保存</van-button>
          </div>
        </van-form>
      </van-tab>
    </van-tabs>
    <van-cell-group>


    </van-cell-group>
  </div>
</template>

<script>

import {Button, Cell, CellGroup, Col, Dialog, Field, Form, Icon, Row, Tab, Tabbar, TabbarItem, Tabs, Toast} from 'vant';

export default {
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Field.name]: Field,
    [Button.name]: Button,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    [Form.name]: Form
  },
  data() {
    return {
      headerName: '',
      identificationNumber: '',
      businessAddress: '',
      email: '',
      phone: '',
      remarks: '',
      loginloading: false,
      bankAccount: '',
      memType: '',
      disableUp: true,
      id: ''
    }
  },
  mounted(){
    // this.loginOrRegister()
    this.init()
  },
  methods:{
    init(){
      var s = JSON.parse(localStorage.getItem("login_data"))
      this.headerName = s.memName
      this.identificationNumber = s.nsrsbh
      this.businessAddress = s.address
      this.email = s.memEmail
      this.phone = s.memMobileno
      this.remarks = s.remarks
      // this.loginloading = s.loginloading
      this.bankAccount = s.bankAccount
      this.memType = s.memType
      this.id = s.id
    },
    validator(val) {
      return /^((13\d)|(14[5,7,9])|(15[0-3,5-9])|(166)|(17[0,1,3,5,7,8])|(18[0-9])|(19[8,9]))\d{8}/.test(val);
    },
    onClickLeft(){
   
      this.$router.push({path: '/home'});
    },
    updateUserData(vals) {
      if(this.disableUp===true){
        this.disableUp = !this.disableUp
        return ''
      }
      this.$axios
          .post('/common/upDateKpData',
              {
                memMobileno:this.phone,  // 手机号
                memName: this.headerName,// 抬头名称
                memWxId: sessionStorage.getItem("openId"), // 微信openid
                nsrsbh: this.identificationNumber, // 纳税人识别号
                address: this.businessAddress, // 企业地址
                memEmail: this.email, // 邮箱
                remarks: this.remarks, // 备注
                bankAccount: this.bankAccount,
                id: this.id
              })
          .then(data => {
            if(data.code==200){
              Toast(data.message)
              this.$router.push({path: '/home'})
            }else{
              Toast(data.message)
            }
            this.disableUp = !this.disableUp
          })
          .catch(erro => {
            reject(erro);
          });
    }
  }
};

</script>

<style lang="less">
.button-group{
  margin: 15px;
  .van-button{
    margin-top: 10px;
  }
}
.user {
  &-poster {
    width: 100%;
    display: block;
  }

  &-group {
    margin-bottom: 15px;
  }

  &-links {
    padding: 15px 0;
    font-size: 12px;
    text-align: center;
    background-color: #fff;

    .van-icon {
      display: block;
      font-size: 24px;
    }
  }
}
.img1{
  background-size: 100% 100%;
  //background: url('../../assets/img/banner.jpg') center center no-repeat;
  height: 100%;
  position: fixed;
  width: 100%
}
*{
  touch-action: none;
}
</style>
